// ABOUTME: Manages safe Branch coverage diagnostics after pre-registration actions fail.
// ABOUTME: Clears diagnostics when later settings actions invalidate the configuration result.
import React from "react";

const ACTIVE_USER_ASSIGNMENT_COVERAGE_TRANSLATION_CODE =
    "whatsappPreRegistration_activeUserAssignmentCoverageUnavailable";

export interface WhatsappPreRegistrationCoverageDiagnostic {
    uncoveredBranches: Array<{ id: string; name: string }>;
    uncoveredBranchCount: number;
}

export const getWhatsappPreRegistrationCoverageDiagnostic = (error: any) => {
    if (
        error?.response?.data?.translationCode !==
        ACTIVE_USER_ASSIGNMENT_COVERAGE_TRANSLATION_CODE
    ) {
        return null;
    }
    const coverage = error?.response?.data?.preRegistrationCoverage;
    const uncoveredBranches = Array.isArray(coverage?.uncoveredBranches)
        ? coverage.uncoveredBranches
              .map((branch: any) => ({
                  id: String(branch?.id || "").trim(),
                  name: String(branch?.name || "").trim()
              }))
              .filter(branch => branch.id && branch.name)
              .slice(0, 50)
        : [];
    const uncoveredBranchCount = Number(coverage?.uncoveredBranchCount);
    if (
        !Number.isSafeInteger(uncoveredBranchCount) ||
        uncoveredBranchCount < 1
    ) {
        return null;
    }
    return {
        uncoveredBranches,
        uncoveredBranchCount: Math.max(
            uncoveredBranchCount,
            uncoveredBranches.length
        )
    } as WhatsappPreRegistrationCoverageDiagnostic;
};

export const useWhatsappPreRegistrationCoverageDiagnostic = () => {
    const [coverageDiagnostic, setCoverageDiagnostic] =
        React.useState<WhatsappPreRegistrationCoverageDiagnostic | null>(null);
    const configGeneration = React.useRef(0);
    const clearDiagnostic = React.useCallback(() => {
        configGeneration.current += 1;
        setCoverageDiagnostic(null);
    }, []);
    const clearForConfigEdit = React.useCallback(
        () => clearDiagnostic(),
        [clearDiagnostic]
    );
    const captureConfigurationGeneration = React.useCallback(
        () => configGeneration.current,
        []
    );
    const showCoverageDiagnostic = React.useCallback(
        (error: any, generation: number) => {
            if (generation !== configGeneration.current) {
                return;
            }
            setCoverageDiagnostic(
                getWhatsappPreRegistrationCoverageDiagnostic(error)
            );
        },
        []
    );

    return {
        coverageDiagnostic,
        clearDiagnostic,
        clearForConfigEdit,
        captureConfigurationGeneration,
        showCoverageDiagnostic
    };
};
